/**
 * Mobile Design Tokens - Flat Structure
 *
 * Centralized color system for mobile components with semantic naming.
 * All colors reference Tailwind config values for consistency with Figma design system.
 */

export const MobileColors = {
  // Brand colors
  primary: '#06512f', // fb-green-900 / new-company-green-dark
  primaryDark: '#00361d', // fb-green-950 (darkest)
  primaryActive: '#087443', // new-company-green-active (FB Green 3)
  accent: '#2C6B4E', // fb-dark-green (medium green)

  // Backgrounds
  backgroundPage: '#ffffff', // White page background
  backgroundCard: '#F4F7F5', // sage-50 (Extra LT Sage) - result cards default
  backgroundCardHover: '#EEF5F2', // pistachio-200 (Pistachio 4) - result cards hover
  backgroundCardActive: '#D6E8E0', // new-company-pistachio-medium (Pistachio 2) - pressed state
  backgroundFilterTag: '#EEF5F2', // pistachio-200 - applied filter tags
  backgroundFilterTagHover: '#C5DED3', // pistachio-100 - filter tag hover
  backgroundBadge: '#E2E2E2', // new-company-gray-border - category badges
  backgroundOverlay: '#f9fafb', // gray-50 - overlays, panels

  // Text colors
  textPrimary: '#191D23', // new-company-gray-900 - primary text
  textSecondary: '#6E6E6E', // new-company-gray-500 - secondary text, labels
  textMuted: '#C4C4C4', // new-company-gray-inactive - placeholder, disabled
  textLink: '#06512f', // fb-green-900 - links, interactive text
  textLinkHover: '#087443', // new-company-green-active - link hover

  // Border colors
  borderDefault: '#E2E2E2', // new-company-gray-border - input borders, dividers
  borderFocus: '#06512f', // fb-green-900 - input focus state

  // Icon colors
  iconPrimary: '#6E6E6E', // new-company-gray-500 - search icon, location pin
  iconSecondary: '#C4C4C4', // new-company-gray-inactive - inactive icons

  // Shadow colors (with opacity)
  shadowSm: 'rgba(0, 0, 0, 0.1)', // Small shadows on cards
  shadowBrand: 'rgba(6, 81, 47, 0.1)', // fb-green-900 with opacity

  // Overlay colors
  overlay: 'rgba(4, 30, 18, 0.5)', // #041E12 at 50% opacity - dark green overlay for modals

  // Backwards compatibility aliases (deprecated - use semantic names above)
  backgroundWhite: '#ffffff', // @deprecated Use backgroundPage instead
  backgroundSelected: '#E5ECE7', // @deprecated Use backgroundFilterTag or backgroundCardHover
  backgroundHover: '#EEF5F2', // @deprecated Use backgroundCardHover instead
  backgroundActive: '#D6E8E0', // @deprecated Use backgroundCardActive instead
  backgroundLight: '#f3f4f6', // @deprecated Use backgroundOverlay instead
  badgeBackground: '#E2E2E2', // @deprecated Use backgroundBadge instead
  borderMedium: '#E2E2E2', // @deprecated Use borderDefault instead
} as const
